import { createElement } from "react";
import React from "react";
import * as react from "react";
import { TaskMsg, useFeliz_UseElmish_React__React_useTaskDispatch_Static } from "../hooks/UseTaskDispatch.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { unwrap, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Entity__get_Name, Entity__get_Id } from "../ClientTypes.fs.js";
import { Locations_MoveToArea, Locations_UpdateLocation, Locations_CreateLocation } from "../ServerTypes.fs.js";
import { moveFacility, update as update_1, create as create_2 } from "../Api/Locations.fs.js";
import { Modal_ModalWithBreakdown } from "./Modal.fs.js";
import { stringHash, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { tryHead, length, choose, singleton, cons, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { EntitySelector } from "../components/EntitySelector.fs.js";
import { List_groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";

export function Create(createInputProps) {
    let xs_7, elms_1, elms, elms_2;
    const close = createInputProps.close;
    const projectId = createInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const areaOpt = patternInput_2[0];
    let create_1;
    const dependencies_1 = [name, areaOpt];
    create_1 = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, "Create"]));
                const create = new Locations_CreateLocation(name, map(Entity__get_Id, areaOpt));
                taskDispatch(new TaskMsg(2, [taskId]));
                return create_2(projectId, create).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_7 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_2 = ofArray([createElement("label", {
            className: "label",
            children: "Area",
        }), createElement(EntitySelector, {
            projectId: projectId,
            entityType: "area",
            onSelectedEntityChange: patternInput_2[1],
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))], react.createElement(react.Fragment, {}, ...xs_7)),
        submit: create_1,
        submitText: "Create",
        tasks: patternInput[0],
        title: "Create",
    });
}

export function Update(updateInputProps) {
    let xs_5, elms_1, elms;
    const close = updateInputProps.close;
    const location = updateInputProps.location;
    const projectId = updateInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(location.Name);
    const name = patternInput_1[0];
    let updates;
    const dependencies_1 = [name];
    updates = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, `Update ${name}`]));
                const update = new Locations_UpdateLocation(name);
                taskDispatch(new TaskMsg(2, [taskId]));
                return update_1(projectId, location.Id, update).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_5 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))], react.createElement(react.Fragment, {}, ...xs_5)),
        submit: updates,
        submitText: "Update",
        tasks: patternInput[0],
        title: "Update",
    });
}

export function MoveToArea(moveToAreaInputProps) {
    let elms;
    const close = moveToAreaInputProps.close;
    const locations = moveToAreaInputProps.locations;
    const projectId = moveToAreaInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const areaOpt = patternInput_1[0];
    let initialArea;
    const dependencies_1 = [locations];
    initialArea = reactApi.useMemo(() => {
        const areaIds = choose((m) => m.AreaId, locations);
        if (length(List_groupBy((x) => x, areaIds, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: stringHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(areaIds);
        }
    }, dependencies_1);
    let moves;
    const dependencies_1_1 = [areaOpt];
    moves = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (areaOpt == null) {
                return Promise.resolve();
            }
            else {
                const area = areaOpt;
                const move = new Locations_MoveToArea(Entity__get_Id(area));
                return PromiseBuilder__For_1565554B(promise, locations, (_arg) => {
                    const location = _arg;
                    taskDispatch(new TaskMsg(0, [location.Id, `Move ${location.Name} To Facility : ${Entity__get_Name(area)}`]));
                    taskDispatch(new TaskMsg(2, [location.Id]));
                    return moveFacility(projectId, location.Id, move).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [location.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [location.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Area",
        }), createElement(EntitySelector, {
            projectId: projectId,
            entityType: "area",
            initialEntity: unwrap(initialArea),
            onSelectedEntityChange: patternInput_1[1],
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: moves,
        submitText: "Move",
        tasks: patternInput[0],
        title: "Move To Area",
    });
}

